<template>
  <div class="details">
    <i
      class="el-icon-close"
      style="position: absolute;left: 3px; top: 5px; font-size: 25px; cursor: pointer;"
      @click="$emit('close')"
    />
    <div class="details_add">
      <div class="add_item">
        <span class="item_title">投放组</span>
        <span class="item_non">{{ drawerItem.release_group_name }}</span>
      </div>
      <div class="add_item">
        <span class="item_title">上级</span>
        <el-select
          v-model="addParameter.parent_leader_id"
          placeholder="请选择"
          filterable
          :disabled="isP"
          @clear="addParameter.parent_leader_id = null"
        >
          <el-option
            v-for="item in tableData.group_user"
            :key="item.user_id"
            :label="item.nickname"
            :value="item.user_id"
          />
        </el-select>
      </div>
      <div class="add_item">
        <span class="item_title">投手</span>
        <el-select
          v-model="addParameter.user_id"
          placeholder="请选择"
          filterable
          :disabled="isP"
          @clear="addParameter.user_id = null"
        >
          <el-option
            v-for="item in tableData.user"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-button
        type="primary"
        style="margin-left: 310px"
        @click="addPitcher"
      >添加</el-button>
    </div>
    <div class="details_contentArea">
      <el-table
        v-loading="loading"
        :data="list"
        max-height="500"
        row-key="id"
        border
        style="width: 80%; margin:0 auto;"
        :tree-props="{children: 'child'}"
      >
        <el-table-column
          prop="user_id"
          label="用户id"
        />
        <el-table-column
          prop="user_name"
          label="用户名"
        />
        <el-table-column label="操作">
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="deletePitcher(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </div>

  </div>
</template>

<script>
import { getListOfPitchersInTheLaunchGroup, addOfPitchersInTheLaunchGroup, deleteOfPitchersInTheLaunchGroup } from '@/api/TKreleaseGroup.js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    // PaginationRight
  },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'child',
        label: 'user_name'
      },
      tableData: {},
      isP: true,
      app_ids: null,
      pageinfo: {
        page: 1,
        pageSize: 10
      },
      parameter: {
        page: 1,
        pageSize: 10,
        group_id: this.drawerItem.id
      },
      addParameter: {
        group_id: this.drawerItem.id,
        user_id: null
      },
      loading: false,
      list: []
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
    setTimeout(() => {
      this.isP = false
    })
  },
  methods: {
    handleNodeClick(v) {
      console.log('v', v)
    },
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getListOfPitchersInTheLaunchGroup(this.parameter)
      console.log('data:', data)
      this.tableData = data.data
      this.list = [data.data.list]
      this.loading = false
    },
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },

    // 添加投手
    async addPitcher() {
      let text = null
      this.addParameter.user_id || (text = '请选择投手')
      // this.addParameter.parent_leader_id = this.addParameter.user_id
      text || (await addOfPitchersInTheLaunchGroup({ ...this.addParameter, feishu_account: this.app_ids }))
      text || this.getDataList()
      text || ((this.addParameter.user_id = null), (this.app_ids = null))
      this.$message({
        message: text || '添加成功',
        type: text ? 'warning' : 'success'
      })
    },

    // 删除投手
    async deletePitcher(row) {
      await deleteOfPitchersInTheLaunchGroup({ id: row.id })
      this.getDataList()
      this.$message({
        message: '删除成功',
        type: 'success'
      })
    },
    querySearch(queryString, cb) {
      // let results = []
      // if (queryString) {
      //   const findout = this.tableData.user.filter((x) => firstCharFilter(x, this.querySearch))
      //   results = findout.map(x => ({ ...x, value: '[lavel: ' + x.label + ': name: ' + x.name + ']' }))
      // } else {
      //   results = this.tableData.user.map(x => ({ ...x, value: x.label }))
      // }
    }
  }
}
</script>

<style scoped>
.details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
}

.details_add {
  width: 80%;
  margin: 0 auto;
}

.add_item {
  margin-bottom: 15px;
}

.item_title {
  display: inline-block;
  width: 100px;
}

.details_contentArea {
  margin-top: 50px;
  max-height: 500px;
}
</style>
